<template>
  <section class="overview" v-if="ready">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        My Dashboard&nbsp;
      </h1>
      <overview-card
        class="mt-3"
        :completed-lessons="me.individual_meta.completed_lessons"
        :badges-awarded="0"
      />
      <notifications type="individuals" />
      <!-- <badges v-if="useBadges && me" /> -->
      <v-card class="my-4" v-if="todoList && todoList.length">
        <v-toolbar color="primary" flat dark>
          <v-toolbar-title>To do list</v-toolbar-title>
        </v-toolbar>
        <v-row class="to-do-row" v-for="(todo, key) in todoList" :key="key">
          <v-col cols="8" v-if="todo.in_progress == 0">
            You have to start {{ todo.lesson }} on class
            {{ todo.class_name }}
          </v-col>
          <v-col cols="8" v-else>
            You have started {{ todo.lesson }} on class {{ todo.class_name }}
          </v-col>
          <v-col cols="4">
            <v-btn
              color="secondary"
              class="primary--text button_google_tag_manager"
              data-category="user"
              data-action="click"
              :data-label="`started lesson : ${todo.lesson}`"
              @click="startLesson(todo)"
            >
              {{
                todo.in_progress == 0
                  ? `click here to start ${lessonTerm}`
                  : `click here to continue ${lessonTerm}`
              }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-row v-if="me" class="mb-4">
        <v-col cols="12">
          <result-overview @loaded="quizLoaded = true" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import ResultOverview from '@/modules/auth/views/results/ResultOverview'
import Auth from '@/modules/auth/models/Auth'
import Notifications from './overview/Notifications'
import { mapState } from 'vuex'
// import Badges from '@/modules/badge/views/Badges'
import OverviewCard from '@/modules/auth/views/dashboard/OverviewCard'

export default {
  name: 'Overview',
  components: {
    Notifications,
    /* Badges, */
    ResultOverview,
    OverviewCard
  },
  data() {
    return {
      ready: false,
      todoList: [],
      quizLoaded: false
    }
  },
  computed: {
    me() {
      return Auth.query()
        .where('type', 'individual')
        .first()
    },
    lessonCount() {
      return Lesson.query().count()
    },
    ...mapState(['bucketUrl', 'useBadges', 'lessonTerm'])
  },
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  methods: {}
}
</script>

<style lang="scss">
.overview {
  .to-do-row {
    margin: 0;
    overflow: auto;
  }
}
</style>
